import { FormattedMessage } from 'react-intl';

import { DurationParts } from '../../utils/to-duration-metric';

const DaysLabel = ({ count }: { count: number }) => (
    <FormattedMessage
        id='dates.days'
        defaultMessage='{count, plural, one {# day} other {# days}}'
        values={{ count }}
    />
);

const HoursLabel = ({ count }: { count: number }) => (
    <FormattedMessage
        id='dates.hours'
        defaultMessage='{count, plural, one {# hour} other {# hours}}'
        values={{ count }}
    />
);

const MinutesLabel = ({ count }: { count: number }) => (
    <FormattedMessage
        id='dates.minutes'
        defaultMessage='{count, plural, one {# minute} other {# minutes}}'
        values={{ count }}
    />
);

export const DurationMetricLabel = ({ days, hours, minutes }: DurationParts) => {
    if (days > 0 && hours > 0) {
        return (
            <>
                <DaysLabel count={days} /> <HoursLabel count={hours} />
            </>
        );
    }

    if (days > 0) {
        return <DaysLabel count={days} />;
    }

    if (hours > 0) {
        return <HoursLabel count={hours} />;
    }

    return <MinutesLabel count={minutes} />;
};
